import {
    SAVE_CATERING_ADDRESS,
    UPDATE_CATERING_ADDRESS,
    SET_CATERING_SCHEDULE,
    CLEAR_CATERING_SCHEDULE,
    RESTORE_CATERING_DATA
} from './actions'

const initialState = {
    address: null,
    schedule: {
        date: null,
        time: null,
        isValid: false
    },
    store: null,
}

const cateringReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case SAVE_CATERING_ADDRESS:
            return {
                ...state,
                address: payload.address,
                store: payload.store,
            }

        case UPDATE_CATERING_ADDRESS:
            return {
                ...state,
                address: payload.address,
                schedule: payload.schedule,
                store: payload.store,
            }

        case SET_CATERING_SCHEDULE:
            return {
                ...state,
                schedule: payload.schedule
            }

        case CLEAR_CATERING_SCHEDULE:
            return {
                ...state,
                schedule: {
                    date: null,
                    time: null,
                    isValid: false
                },
                isValid: !!(state.address && state.store)
            }

        case RESTORE_CATERING_DATA:
            const { address, schedule, store } = payload
            return {
                ...state,
                address: address || null,
                schedule: schedule ? {
                    ...schedule,
                    isValid: !!(schedule.date && schedule.time)
                } : initialState.schedule,
                store: store || null,
                isValid: !!(address && ((schedule?.date && schedule?.time) || store))
            }

        default:
            return state
    }
}

export default cateringReducer
